import React from 'react';
import whoAreWe from '../assets/svg/Home SVGs/undraw_faq_rjoy.svg';
import OurView from '../assets/svg/undraw_searching_p5ux.svg';
import Github from '../assets/svg/Icon awesome-github.svg';
import Linkedin from '../assets/svg/Icon awesome-linkedin.svg';
import Mohammed from '../assets/IMG_1751.JPG';

import Qamer from '../assets/IMG_8864.JPG';
import Team from '../assets/placeholder.jpg';
import mursaleen from '../assets/mursaleen.JPG';

const AboutUs = () => {
  return (
    <div>
      <div id='about' className='flex flex-col '>
        <div className='lg:flex justify-between'>
          <div className='hidden lg:block lg:pl-20 lg:pt-10'>
            <img
              className='lg:ml-32 lg:mt-16'
              src={whoAreWe}
              width='450'
              height='450'
              alt='who are we ?'
            />
          </div>
          <div className='flex justify-center mt-12 ml-20 lg:hidden lg:pl-20 lg:pt-10'>
            <img
              className='lg:ml-40 lg:mt-16'
              src={whoAreWe}
              width='250'
              height='250'
              alt='who are we ?'
            />
          </div>
          <div className='p-4 lg:p-0 lg:pr-8 text-right lg:w-1/4 lg:m-10 lg:m-24 self-end relative leading-loose'>
            <h1 className='text-2xl lg:mb-8 '>من نحن ؟</h1>
            <p className=''>
              نحن فريق "نبيل" فريق من المبرمجين الشغوفين بمساعدة الناس وتقديم
              خدمة لتنظيم العلاقة بين المتبرعين و المتطوعين والمستلمين بصورة
              افضل و عملنا جاهدين على توظيف قدراتنا وجهدنا في تصميم الموقع
              لاطلاق النسخة الاولية من "نبيل" في الوقت المناسب
            </p>
          </div>
        </div>
        <div className='lg:flex justify-between'>
          <div className='flex justify-center lg:hidden lg:pl-20 lg:pb-20 pb-6'>
            <img
              className='mr-16 lg:mr-40 lg:mt-5'
              src={OurView}
              width='200'
              height='200'
              alt='our view ?'
            />
          </div>
          <div className=' text-right lg:w-1/4  p-4 lg:p-0 lg:ml-48 lg:-mt-16 lg:pb-8  lg:self-start self-end leading-loose'>
            <h1 className='text-2xl lg:mb-8'> ما هي نظرتنا ؟</h1>
            <p>
              هدفنا الاساسي هو تقديم طريقة جديدة استعانة بالتكنولوجيا لخلق مفهوم
              جديد من تنظيم الاعمال التطوعية ومساعدة المتعففين لتلبية احتياجاتهم
              بسرية تامة مع تجنب خدش سرية تلك الخدمة المقدمة لهم كان من الواضح
              ان الغالبية العظمى من الناس تحاول تقديم خدمة فعالة عن بعد في الحرب
              ضد "كوفيد-19" ومساعدة الناس المتضررين لتخطي الازمة باقل قدر ممكن
              من الاضرار لذا من هذا المنطلق باشرنا عملنا sفي "نبيل" رغبة منا في
              مساعدة الناس المتعففين و تشكيل حافز للافراد الاخرين القادرين على
              تسخير قدراتهم لمساعدة المجتمع خلال الازمة الراهنة
            </p>
          </div>
          <div className='hidden lg:block pl-20 pb-20'>
            <img
              className='mr-40 mt-5'
              src={OurView}
              width='400'
              height='400'
              alt='our view ?'
            />
          </div>
        </div>
      </div>
      <div className='pt-12'>
        <p className='text-center text-4xl pb-16'>التقي بفريقنا</p>
        <div className='flex flex-col md:flex-row md:flex-wrap md:justify-evenly md:mb-24'>
          <div className='mb-2'>
            <img
              className='rounded-full h-48 w-48 circle-shadow block m-auto object-fill'
              src={Qamer}
              alt='Team Member'
            />
            <p className='text-center pt-5 text-2xl text-black'>
              Qamar Mudhafar
            </p>
            <p className='text-center text-lg text-black pb-2'>
              Business Development Associate
            </p>
            <div className='flex justify-center pt-2 pb-8'>
              <a target='_blanck' href='http://linkedin.com/in/qamar-mudhafar'>
                <img className='pr-3' src={Linkedin} alt='github' />
              </a>
              <a target='_blanck' href='https://github.com/qamarmudhafar'>
                <img src={Github} alt='linkedin' />{' '}
              </a>
            </div>
          </div>

          <div className='mb-2'>
            <img
              className='rounded-full h-48 w-48 circle-shadow block m-auto'
              src={Team}
              alt='Team Member'
            />
            <p className='text-center pt-5 text-2xl text-black'>Saja Amer</p>
            <p className='text-center text-lg text-black pb-2'>
              Front-end & Firebase Back-end Developer
            </p>
            <div className='flex justify-center pt-2 pb-8'>
              <a
                target='_blanck'
                href='https://www.linkedin.com/in/saja-amer-8384511a4/'
              >
                <img className='pr-3' src={Linkedin} alt='github' />
              </a>
              <a target='_blanck' href='https://github.com/saja25'>
                <img src={Github} alt='linkedin' />{' '}
              </a>
            </div>
          </div>
        </div>
        <div className='flex flex-col md:flex-row md:flex-wrap md:justify-evenly mb-24 md:-mx-24'>
          <div className='mb-2'>
            <img
              className='rounded-full h-48 w-48 circle-shadow block m-auto object-cover'
              src={Mohammed}
              alt='Team Member'
            />
            <p className='text-center pt-5 text-2xl text-black'>Mohammed Ali</p>
            <p className='text-center text-lg text-black pb-2'>
              Front-end Web Developer
            </p>

            <div className='flex justify-center pt-2 pb-8'>
              <a
                target='_blanck'
                href='https://www.linkedin.com/in/mohammed-ali-456aaa1a2/'
              >
                <img className='pr-3' src={Linkedin} alt='github' />
              </a>
              <a target='_blanck' href='https://github.com/klay964'>
                <img src={Github} alt='linkedin' />{' '}
              </a>
            </div>
          </div>

          <div className='mb-2'>
            <img
              className='rounded-full h-48 w-48 circle-shadow block m-auto'
              src={mursaleen}
              alt='Team Member'
            />
            <p className='text-center pt-5 text-2xl text-black'>Mursaleen</p>
            <p className='text-center text-lg text-black pb-2'>
              UI/UX Designer
            </p>
            <div className='flex justify-center pt-2 pb-8'>
              <a
                target='_blanck'
                href='https://www.linkedin.com/in/mursaleen-taqi-b94430161/'
              >
                <img className='pr-3' src={Linkedin} alt='github' />
              </a>
              <a target='_blanck' href='https://github.com/mursaleentaqi'>
                <img src={Github} alt='linkedin' />{' '}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
